import html2canvas from 'html2canvas';
window.html2canvas = html2canvas;
/**
* Loads the orders/history.utils.js module as <order-utils>
* You can instanciate this within a component using `this.instance(`historyUtils'`)`
*/
import historyUtils from './orders/history.utils.js';

Vue.component('historyUtils', {
	data() { return {
		config: this.$config, // Inject config object
		..._.pickBy(historyUtils, v => !_.isFunction(v)), // Import all simple data types
	}},
	methods: _.pickBy(historyUtils, v => _.isFunction(v)), // Import all functions as methods
	created() {
		this.$instance('versioningUtils')
	},
});
/**
* Loads the orders/orderUtils.js module as <order-utils>
* You can instanciate this within a component using `this.instance(`orderUtils'`)`
*/
import orderUtils from './orders/orderUtils';

Vue.component('orderUtils', {
	data() { return {
		config: this.$config, // Inject config object
		..._.pickBy(orderUtils, v => !_.isFunction(v)), // Import all simple data types
	}},
	methods: _.pickBy(orderUtils, v => _.isFunction(v)), // Import all functions as methods
	created() {
		return orderUtils.orderUtilsInit();
	},
});
/**
* Front-end polyfills to apply
*/
import './polyfills/array.flat';
import './polyfills/array.flatMap';
import './polyfills/json.parseSafe';
import './polyfills/json.stringifySafe';
import './polyfills/promise.allLimit';
import './polyfills/promise.allObject';
import './polyfills/promise.allSeries';
import './polyfills/promise.defer';
import './polyfills/promise.isPromiseLike';
import './polyfills/promise.tap';
import './polyfills/promise.timeout';
import './polyfills/regexp.escape';
/**
 * Loads the orders/orderUtils.js module as <order-utils>
 * You can instanciate this within a component using `this.instance(`orderUtils'`)`
 */
import warehouseUtils from "./products/warehouseUtils";
import _ from "lodash";

Vue.component("warehouseUtils", {
  data() {
    return {
      config: this.$config, // Inject config object
      ..._.pickBy(warehouseUtils, (v) => !_.isFunction(v)), // Import all simple data types
    };
  },
  methods: {
    ..._.pickBy(warehouseUtils, (v) => _.isFunction(v)), // Import all functions as methods
  },
  created() {
    this.$debugging = false;
    /** Enables internal assertions */
    this.$debuggingAssertions = true;

    this.$debug("warehouseUtils.vue component created");

    // `this.$debug` won't be defined if you call this as warehouseUtils.refresh()
    return this.refresh();
  },
});
/**
* Loads the projects/projectUtils.js module as <project-utils>
* You can instanciate this within a component using `this.$instance('projectUtils')`
*/
import projectUtils from './projects/projectUtils.js';

Vue.component('projectUtils', {
	data() { return {
		config: this.$config, // Inject config object
		..._.pickBy(projectUtils, v => !_.isFunction(v)), // Import all simple data types
	}},
	methods: _.pickBy(projectUtils, v => _.isFunction(v)), // Import all functions as methods
});
/**
* Loads the returns/returnsUtils.js module as <returns-utils>
* You can instanciate this within a component using `this.$instance('returnsUtils')`
*/
import returnsUtils from './returns/returnsUtils.js';

Vue.component('returnsUtils', {
	data() { return {
		config: this.$config,
		..._.pickBy(returnsUtils, v => !_.isFunction(v)),
	}},
	methods: _.pickBy(returnsUtils, v => _.isFunction(v)),
});
// Expose string-split-by globally
import stringSplitBy from 'string-split-by';
window.stringSplitBy = stringSplitBy;
import benchmarkCore from './services/benchmark';
window.benchmarkCore = benchmarkCore;
var methods = {}; // Method's to glue onto vm.$emit

/**
* Extend the base Vue.prototype.$emit with Vue.prototype.$emit.broadcast()
* This is effectively the same as an $emit.down from the root node
* NOTE: This also broadcasts to app.vue
* @param {string} msg The name of the event to emit
* @param {*} [payload...] The payload of the event
*/
methods.broadcast = (msg, ...payload) => {
	app.vue.$emit.call(app.vue, msg, ...payload);
	app.vue.$emit.down.call(app.vue, msg, ...payload);
};


/**
* Extend the base Vue.prototype.$emit with Vue.prototype.$emit.down() which recurses though all children emitting a message
* NOTE: This does not include the current component level, only the children
* @param {string} msg The name of the event to emit
* @param {*} [payload...] The payload of the event
* @returns {VueComponent} This chainable VM
*/
methods.down = function(msg, ...payload) {
	this.$children.forEach(child => {
		child.$emit.call(child, msg, ...payload);
		child.$emit.down.call(child, msg, ...payload);
	});

	return this;
};


/**
* Extend the base methods.$emit with Vue.prototype.$emit.up() which recurses though all parents emitting a message
* NOTE: This does not include the current component level, only the parents
* @param {string} msg The name of the event to emit
* @param {*} [payload...] The payload of the event
* @returns {VueComponent} This chainable VM
*/
methods.up = function(msg, ...payload) {
	if (!this || !this.$parent) throw new Error('Unable to $emit.up() on non Vue component');
	var node = this;
	while (node.$parent) {
		node = node.$parent;
		node.$emit.call(node, msg, ...payload);
	}

	return this;
};


/**
* Extend the base Vue.prototype.$emit with promise support
* Any function returning a promise will be waited on
* NOTE: As of 2019-07-10 (Vue 2.6.10) it is not possible to glue this as vm.$emit.promise for some reason, maybe one day this will change
* @param {string} msg The name of the event to emit
* @param {*} [payload...] The payload of the event
* @returns {Promise} A promise which will resolve with the Promise.all result of all listeners
*/
methods.promise = function(msg, ...payload) {
	var node = this;
	if (!node || !this._isVue) throw new Error('Unable to $emit.promise() on non Vue component');
	if (!node._events[msg] || !this._events[msg].length) return Promise.resolve(); // No listeners anyway

	return Promise.all(
		node._events[msg].map(e =>
			Promise.resolve(
				e.apply(node, payload)
			)
		)
	).then(responses => responses[0]);
};


/**
* Return if anything is listening to a given event
* This is useful if the event broadcast would involve some non-trivial processing and it would be beneficial to skip if nothing is listening anyway
* @param {string} msg The name of the event to emit
* @returns {boolean} Boolean true if any matching listener is present
*/
methods.hasListeners = function(msg) {
	if (!this || !this.$parent) throw new Error('Unable to $emit.hasSubscribers() on non Vue component');
	return (
		this._events[msg]
		&& this._events[msg].length > 0
	);
};


/**
* Auto emit a message on a timer
* If any listener returns a promise it is waited on
* @param {string} msg The name of the event to emit
* @param {*} [payload...] Optional additional payload for the event
* @param {number} interval When to schedule the event, required and must be numeric
* @returns {VueComponent} This chainable VM
*/
methods.schedule = function(msg, ...payload) {
	if (!this || !this.$parent) throw new Error('Unable to $emit.schedule() on non Vue component');
	if (!this.$emit.scheduleHandles) this.$emit.scheduleHandles = {};

	var interval = payload.pop();
	if (typeof interval != 'number') throw new Error('Last argument to $emit.auto must be a numeric interval');

	this.$emit.scheduleHandles[msg] = {
		message: msg,
		payload,
		interval,
		timer: undefined,
		reschedule: ()=> {
			this.$emit.scheduleHandles[msg].timer = setTimeout(()=> {
				if (!this || !this.$emit.scheduleHandles[msg]) return;
				this.$emit.promise(this.$emit.scheduleHandles[msg].message, ...this.$emit.scheduleHandles[msg].payload)
					.then(()=> this.$emit.scheduleHandles[msg].reschedule)
			}, this.$emit.scheduleHandles[msg].interval);
		},
	};
	this.$emit.scheduleHandles[msg].reschedule(); // Schedule initial timer

	return this;
};


/**
* Release an scheduled emitter
* If called with no arguments all scheduled timers are released
* This function is called automatically whenever a VM is being destroyed
* @param {string|array<string>} [msgs] Messages to unschedule, if omitted all are assumed
* @returns {VueComponent} This chainable VM
*/
methods.unschedule = function(msgs) {
	if (!this.$emit.scheduleHandles) return; // Nothing scheduled anyway
	_.castArray(msgs || Object.keys(this.$emit.scheduleHandles))
		.forEach(msg => {
			clearTimeout(this.$emit.scheduleHandles[msg]?.timer);
			delete this.$emit.scheduleHandles[msg];
		})
};


Vue.mixin({
	beforeCreate() {
		this.$emit = this.$emit.bind(this); // Rebind $emit to this vm so we get the right context

		// Long-winded version of _.mapValues() where we remap each method to a binding of this VM
		Object.assign(this.$emit, Object.fromEntries(
			Object.entries(methods).map(i =>
				[i[0], i[1].bind(this)]
			)
		));
	},
	beforeDestroy() {
		this.$emit.unschedule();
	},
});
import {v4} from 'uuid';
Vue.prototype.$uuid = {
	generate: v4,
};
import { algoliasearch as AlgoliaSearch } from 'algoliasearch'
import { autocomplete } from '@algolia/autocomplete-js'
import { createTagsPlugin } from '@algolia/autocomplete-plugin-tags'
import { createLocalStorageRecentSearchesPlugin } from '@algolia/autocomplete-plugin-recent-searches'

window.autocomplete = {
	AlgoliaSearch,
	autocomplete,
	createTagsPlugin,
	createLocalStorageRecentSearchesPlugin,
}
import Big from 'big.js';
//Big.strict = true; // Error on imprecise conversion
//Big.DP = 50;

// @see https://github.com/MikeMcl/big.js/issues/86#issuecomment-331573255
Big.max = function () {
	var i, y,
	x = new this(arguments[0]);
	for (i = 1; i < arguments.length; i++) {
		y = new this(arguments[i]);
		if (x.lt(y)) x = y;
	}
	return x;
};

Big.min = function () {
	var i, y,
	x = new this(arguments[0]);
	for (i = 1; i < arguments.length; i++) {
		y = new this(arguments[i]);
		if (x.gt(y)) x = y;
	}
	return x;
};

/** 
 *  @class Big
 *  @type {Object}
 *  @method toString
 *  @method toFixed
 *  @method toNumber
 */
window.Big = Big;
import { BroadcastChannel, createLeaderElection } from 'broadcast-channel';
window.BC = {
	BroadcastChannel: BroadcastChannel,
	createLeaderElection: createLeaderElection,
};
import * as d3 from 'd3';
window.d3 = d3;
/**
* Install Handlebars as a browser universal
*/
import handlebars from 'handlebars/dist/handlebars';
window.handlebars = handlebars;
const PDFJS = require('pdfjs-dist')
window.PDFJS = PDFJS;
const semver = require('semver');
window.semver = semver;
/**
* Import sift
*/
import sift from 'sift';
window.sift = sift;
// https://github.com/bjoerge/debounce-promise/blob/master/index.js
function pDebounce(fn, wait = 0, options = {}) {
	let lastCallAt;
	let deferred;
	let timer;
	let pendingArgs = [];
	function debounced(...args) {
		const currentWait = getWait(wait);
		const currentTime = new Date().getTime();

		const isCold = !lastCallAt || currentTime - lastCallAt > currentWait;

		lastCallAt = currentTime;

		if (isCold && options.leading) {
			return options.accumulate
				? Promise.resolve(fn.call(this, [args])).then((result) => result[0])
				: Promise.resolve(fn.call(this, ...args));
		}

		if (deferred) {
			clearTimeout(timer);
		} else {
			deferred = defer();
		}

		pendingArgs.push(args);
		timer = setTimeout(flush.bind(this), currentWait);

		if (options.accumulate) {
			const argsIndex = pendingArgs.length - 1;
			return deferred.promise.then((results) => results[argsIndex]);
		}

		return deferred.promise;
	}

	debounced.cancel = function() {
		clearTimeout(timer);
		pendingArgs = [];
		if (deferred) {
			deferred.resolve();
			deferred = null;
		}
	};

	return debounced;

	function flush() {
		const thisDeferred = deferred;
		clearTimeout(timer);

		Promise.resolve(
			options.accumulate ? fn.call(this, pendingArgs) : fn.apply(this, pendingArgs[pendingArgs.length - 1]),
		).then(thisDeferred.resolve, thisDeferred.reject);

		pendingArgs = [];
		deferred = null;
	}
}

function getWait(wait) {
	return typeof wait === 'function' ? wait() : wait;
}

function defer() {
	const deferred = {};
	deferred.promise = new Promise((resolve, reject) => {
		deferred.resolve = resolve;
		deferred.reject = reject;
	});
	return deferred;
}

export default pDebounce;

window.throttleWithPromise = pDebounce;
/**
* Import the vue-js-toggle-button control
* @param {boolean} [value=false] Initial state of the toggle button
* @param {boolean} [sync=false] If set to true, will be watching changes in value property and overwrite the current state of the button whenever value prop changes
* @param {number} [speed=300] Transition time for the animation
* @param {boolean} [disabled=false] Button does not react on mouse events
* @param {string} [color='#75C791'] Color of the button when checked
* @param {boolean|Object} [labels=true] If Boolean - shows/hides default labels ("on" and "off"), if object use `{checked: 'on', unchecked: 'off'}`
* @param {string|Object} [switch-color='#BFCBD9'] Color or background property of the switch when checked, if object use `{checked: '#25EF02', unchecked: 'linear-gradient(red, yellow)'}`
* @param {Number} [width=50] Width of the button
* @param {Number} [height=22] Height of the button
* @param {Number} [margin=3] Space between the switch and background border
* @param {String} [name=undefined] Name to attach to the generated input field
* @param {Number} [font-size=undefined] Font size
*
* @emits change Emitted as (newValue <boolean>) when the value changes
*
* @example Use event emitters to update a value
* <toggle-button
*   :value="false"
*   color="#82C7EB"
*   :labels="true"
*   :labels="{checked: 'On', unchecked: 'Off'}"
*   @change="someValue = $event.value"
* />
*
* @example Sync a value
* <toggle-button v-model="someValue"/>
*
* @example Toggle button within a BS4 form
* <div class="form-group row">
*   <label class="col-4 col-form-label">Allow upload</label>
*   <div class="col-8 col-form-label">
*     <toggle-button v-model="someValue"/>
*   </div>
* </div>
*/
import ToggleButton from 'vue-js-toggle-button';
Vue.use(ToggleButton);
/**
 * Import the vuejs-datepicker as v-date
 * @url https://www.npmjs.com/package/vuejs-datepicker
 *
 * @example Simple date binding
 * <v-date v-model="myDate"/>
 *
 * @example Expanded binding
 * <v-date :value="myDate" @selected="myDate = $event"/>
 */

import Datepicker from '@sum.cumo/vue-datepicker';
// FIXME: refuses to import style sheet

Vue.component('v-date', Datepicker);
/**
* Importer for the v-draggable directive
* @url https://github.com/SortableJS/Vue.Draggable
*
* @example
*

*/
import draggable from 'vuedraggable'
Vue.use(draggable);
/**
* Importer for the v-mask directive
* @url https://github.com/probil/v-mask
*
* @example Mask a time + date input
* <div v-mask="'##/##/#### ##:##'"/>
*
* @example Mask credit card input
* <div v-mask="'#### #### #### ####'"/>
*
* @example Mask a number with a thousands seperator
* <div v-mask="'#,###'"/>
*/
import VueMask from 'v-mask'
Vue.use(VueMask);
import {VueSelect} from 'vue-select';
Vue.component('v-select', VueSelect);
/**
* Wrapper for the Quill vue2-editor WYSIWYG wrapper as <wysiwyg/>
*
* @url https://github.com/davidroyer/vue2-editor
* @param {string} [value] The existing HTML content to display
* @param {string} [toolbar='full'] Type of toolbar UI to use. ENUM: 'none', 'simple', 'full'
*
* @emits change Emitted as `(html)` when the value changes
*
* @example Simple WYSIWYG component
* <wysiwyg
*   :value="body"
*   @change="body = $event"
* />
*/
import {VueEditor, Quill} from 'vue2-editor';

Vue.component('wysiwyg', {
	components: {VueEditor},
	emits: ["change"],
	props: {
		toolbar: {type: String, default: 'full', validator: v => ['none', 'simple', 'full'].includes(v)},
		value: {type: String},
		disabled: {type: Boolean, default: false},
	},
	methods: {
		/**
		* Focus the WYSIWYG edit area
		*/
		focus() {
			$(this.$el).find('.ql-editor').focus();
		},
	},
	mounted() {
		this.$watch('toolbar', {
			immediate: true,
			handler() {
				$(this.$el).toggleClass('quill-no-toolbar', this.toolbar == 'none');
			},
		});
	},
	render(h) {
		return h('vue-editor', {
			props: {
				disabled: this.disabled,
				value: this.value,
				editorToolbar: this.toolbar == 'none' ? [[]] : [
					this.toolbar == 'full' && [{header: [false, 1, 2, 3, 4, 5, 6]}],
					[
						'bold',
						'italic',
						'underline',
						'strike',
					],
					[
						{align: ''},
						{align: 'center'},
						{align: 'right'},
						{align: 'justify'}
					],
					[
						'blockquote',
						'code-block',
					],
					this.toolbar == 'full' && [
						{list: 'ordered'},
						{list: 'bullet'},
						{list: 'check'}
					],
					this.toolbar == 'full' && [
						{indent: '-1'},
						{indent: '+1'}
					],
					[
						{color: []},
						{background: []},
					],
					this.toolbar == 'full' && [
						'link',
						'image',
						'video',
					],
					[
						'clean', // remove formatting button
					],
				].filter(Boolean),
			},
			on: {
				input: v => this.$emit('change', v),
			},
		});
	},
});
/**
 * Integrate into Vue2 as <tinymce/>
 * This component is basicly a wrapper with some defaults set
 *
 * @param {string} value The intial value to set to
 * @emits change Emitted as `(newValue: String)` when any change occurs
 * @url https://www.tiny.cloud/docs/tinymce/6/vue-ref/
 *
 * @example Simple HTML editing
 * <tinymce :value="html" @change="html = $event"/>
 */
import Editor from '@tinymce/tinymce-vue';

Vue.component('tinymce', {
	components: { Editor },
	data() { return {
		initialValue: '',
		_editor: null,
		_pendingContent: null,
	}},
	props: {
		value: String,
		convertImages: { type: Boolean, default: false },
	},
	methods: {
		// Set editor content immediately if ready, otherwise queue it for when init fires
		setContent(html) {
			if (this._editor) {
				this._editor.setContent(html);
			} else {
				this.initialValue = html;
				this._pendingContent = html;
			}
		},
		changeValue(template) {
			var div = document.createElement('div');
			div.innerHTML = template;
			var images = div.getElementsByTagName('img');

			if (this.convertImages && images.length > 0) {
				return Promise.all(Array.from(images).map(image => this.convertImgToBase64URL(image.src)
						.then(res => image.setAttribute('src', res))
					))
					.then(() => div.innerHTML);
			} else {
				return Promise.resolve()
					.then(() => div.innerHTML);
			}
		},


		convertImgToBase64URL(url) {
			return new Promise ((resolve, reject) => {
				var canvas = document.createElement('CANVAS');
				var img = document.createElement('img');
				img.setAttribute('src', url);
				img.setAttribute('crossorigin', 'anonymous');
				img.onload = function () {
					canvas.height = img.height;
					canvas.width = img.width;
					var ctx = canvas.getContext('2d');
					ctx.drawImage(img, 10, 10, img.width, img.height);
					const toBase64 = canvas.toDataURL();
					resolve(toBase64);
				};
				img.onerror = function (error) {
					error = 'Could not load image, please check that the file is accessible and an image!';
					reject(error);
				};
			})
		},

		// Trigger this when needing to change the template of tinymce
		refresh() {
			this.initialValue = this.value;
		}
	},
	created() {
		this.initialValue = this.value; // Decoupled value to prevent cancerous TinyMCE from performing circular update loops
	},
	render(h) {
		return h('Editor', {
			props: {
				apiKey: 'pw7cdrsp76v59trzbewg5wt0l30cvmmkmxabitdr090wazr1',
				value: this.initialValue,
				theme: 'advanced',
				plugins: 'autoresize codesample lists image media link',
				// width: '100%',
				min_height: 500,
				toolbar: 'styleselect | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | blockquote codesample | numlist bullist | outdent indent | forecolor backcolor | link insertfile image media | removeformat ',
				// autoresize_min_height: 1000,
				// autoresize_max_height: 1500,
				resize: true,
				branding: false,
			},
			on: {
				init: (evt, editor) => {
					this._editor = editor;
					if (this._pendingContent !== null) {
						editor.setContent(this._pendingContent);
						this._pendingContent = null;
					}
				},
				input: ($event) => {
					this.changeValue($event)
						.then(res => this.$emit('change', res));
				},
			},
		});
	},
});
/**
* Loads the widget/versioning/versionUtils.js module as <version-utils>
* You can instanciate this within a component using `this.instance(`orderUtils'`)`
*/

import versionUtils from './widgets/versioning/versioningUtils.js';

Vue.component('versioningUtils', {
	data() { return {
		config: this.$config, // Inject config object
		..._.pickBy(versionUtils, v => !_.isFunction(v)), // Import all simple data types
	}},
	methods: _.pickBy(versionUtils, v => _.isFunction(v)), // Import all functions as methods
	created() {
	},
});